import React, { lazy, Suspense, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import api from "../../services/api";
import "./ProductDetailsLayout.css";
import { addToCart, decreaseFromCart } from "../../redux/state/cart/CartSlice";
import { useDispatch, useSelector } from "react-redux";

import { roundPrice } from "../../services/utils/mathRoundHelper";
import { CopyIcon, FacebookIcon, FacebookMessengerIcon, LikeIcon, TwitterIcon, ViewIcon, WhatsappIcon } from "../Icons/icons";
import Helmet from "../SEO/Helmet";
import ReviewSection from "../features/product/components/ReviewSection";
const ImageZoomLaytout = lazy(() => import('./ImazeZoomLaytout'));


const ProductDetailsLayout = () => {

  const { slugToProduct } = useParams();
  const url = window.location.href;
   const dispatch = useDispatch();


  const [productDetails, setProductDetails] = useState(null);
  const [activeImage, setActiveImage] = useState(null);
 
  const [likeCount, setLikeCount] = useState(0);
  const [viewCount, setViewCount] = useState(0);
  const [liked, setLiked] = useState(false);

  // ▼ GET CART ITEMS FROM REDUX
  const { cartItems } = useSelector((state) => state.cart);

  function fetchData(slugToProduct) {
    api.get(`fetch-product-details?slug_to_product=${slugToProduct}`).then((res) => {
      setProductDetails(res.data);
    });
  }

  useEffect(() => {
    fetchData(slugToProduct);
  }, [slugToProduct]);

  useEffect(() => {
       if (!productDetails) return;

      if (productDetails?.product_images?.length > 0) {
        const primary = productDetails.product_images.find(
          (img) => parseInt(img.is_primary) === 1
        );

        setActiveImage(
          primary?.image_file_name ||
          productDetails.product_images[0]?.image_file_name
        );
      }
  
    // COUNTS
    setLikeCount(Number(productDetails.like_count || 0));
    setViewCount(Number(productDetails.view_count || 0));
     
  }, [productDetails]);

  useEffect(() => {
  if (!productDetails?.id) return;

  const updateView = async () => {
    try {
      await api.post("product-view-increase", {
        product_id: productDetails.id,
      });

      setViewCount((prev) => prev + 1);
    } catch (err) {
      console.log("View error:", err?.response || err.message);
    }
  };

  updateView();
}, [productDetails?.id]);


 // LIKE
  const handleLikeCount = async () => {
    try {
      // PREVENT MULTIPLE CLICK
      if (liked) return;

      const res = await api.post("product-like", {
        product_id: productDetails.id,
      });

      // SERVER VALUE USE
      if (res.data.status) {
        setLikeCount(Number(res.data.like_count));
        setLiked(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

const openShare = (shareUrl, size = "600,400") =>
    window.open(shareUrl, "_blank", `width=${size.split(",")[0]},height=${size.split(",")[1]}`);

  const share = (type) => {
    const encodedUrl = encodeURIComponent(url);
    const text = encodeURIComponent(`Check this product: ${product?.product_name || ""}`);

    const urls = {
      whatsapp: `https://wa.me/?text=${text}%20${encodedUrl}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      messenger: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`,
    };

    openShare(urls[type]);
  };

  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };


  if (!productDetails) {
    return <div className="text-center py-5">Loading...</div>;
  }

  // Price
  const unitPrice = Number(productDetails.product_unit_price);
  const discount = Number(productDetails.product_discount);
  const discountedPrice = roundPrice(unitPrice - (unitPrice * (discount / 100)));

  // Product object for cart
  const product = {
    id: productDetails.id,
    product_name: productDetails.product_name,
    image: productDetails.product_images?.find(img => parseInt(img.is_primary) === 1)?.image_file_name || productDetails.product_images?.[0]?.image_file_name || null,
    product_info: productDetails.product_info,
    product_description: productDetails.product_description,
    slug_to_product: productDetails.slug_to_product,
    discountedPrice
  };

  // ▼ FIND THIS PRODUCT IN CART
  const cartItem = cartItems.find(
    item => Number(item.id) === Number(product.id)
  );
  // ▼ GET CART QUANTITY — default 0
  const cartQuantity = cartItem ? cartItem.cartQuantity : 0;


  return (
    <>
      <Helmet
        title={product.product_name}
        description={product.product_name}
        image={`${process.env.REACT_APP_IMAGEBASE_URL}products/${product.image}`}
        url={window.location.href}
        type="product"
      />

      <div className="container py-4">
          <div className="row g-4">
              <div className="col-md-7">
                  <div className="product-gallery d-flex gap-3">
                    {/* LEFT - THUMBNAILS */}
                    <div className="product-thumbnails d-flex flex-column gap-2">

                      {productDetails?.product_images?.length > 0 &&
                        productDetails.product_images.map((img) => (
                          <img
                            key={img.id}
                            src={`${process.env.REACT_APP_IMAGEBASE_URL}products/${img.image_file_name}`}
                            alt={img.image_file_name}
                            className={`img-thumbnail cursor-pointer ${
                              activeImage === img.image_file_name ? "border border-primary" : ""
                            }`}
                            style={{ width: "400px" }}
                            onClick={() => setActiveImage(img.image_file_name)}
                          />
                        ))}

                    </div>

                    {/* RIGHT - MAIN IMAGE */}
                    <div className="flex-grow-1">
                          <Suspense fallback={<div className="text-center">Loading...</div>}>
                            <ImageZoomLaytout
                              className="img-fluid rounded w-100"
                              src={ activeImage ? `${process.env.REACT_APP_IMAGEBASE_URL}products/${activeImage}` : "" }
                              alt={activeImage}
                            />
                          </Suspense>
                    </div>
                  </div>
              </div>
              <div className="col-md-5">
                <h3>{product.product_name}</h3>
                <div className="text-dark fw-bold cursor-pointer">
                      
                     <div className="d-flex align-items-center gap-2 flex-wrap">
                      <span className="text-success fw-bold">In Stock</span>

                       <div className=" d-flex align-items-center border rounded-pill shadow-sm  px-2 py-1 gap-1 bg-light">
                            <span className="fw-semibold me-2">Share:</span>

                                {/* WhatsApp */}
                                <button className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center share-btn" onClick={() => share("whatsapp")}>
                                  <WhatsappIcon width={18} height={18} />
                                </button>

                                {/* Facebook */}
                                <button className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center share-btn"  onClick={() => share("facebook")}>
                                  <FacebookIcon width={18} height={18} />
                                </button>

                                {/* Messenger */}
                                <button className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center share-btn" onClick={() => share("messenger")}>
                                  <FacebookMessengerIcon width={18} height={18} />
                                </button>

                                {/* Twitter */}
                                <button className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center share-btn" onClick={() => share("twitter")}>
                                  <TwitterIcon width={18} height={18} />
                                </button>

                                  {/* Copy */}
                                <button className="btn btn-light border rounded-circle d-flex align-items-center justify-content-center share-btn" onClick={handleCopyLink}>
                                  <CopyIcon width={32} height={32} />
                                </button>
                                {copied && (
                                  <small className="text-success fw-semibold ms-1">
                                    Copied!
                                  </small>
                                )}
                        
                        </div>  

                      
                    </div>
                 </div>

                <div className="my-2">
                  <span className="text-decoration-line-through text-muted me-2">
                    {unitPrice} ৳
                  </span>
                  <span className="fs-4 fw-bold">{discountedPrice} ৳</span>
                </div>




                {/* QUANTITY */}
                <div className="d-flex align-items-center mb-3">
                  <span className="fw-bold me-3">Quantity</span>

                  <button
                    className="btn btn-outline-dark"
                    onClick={() => dispatch(decreaseFromCart(product))}
                  >
                    –
                  </button>

                  {/* ▼ SHOW LIVE CART QUANTITY */}
                  <span className="px-3 fs-5">
                    {cartQuantity}
                  </span>

                  <button
                    className="btn btn-outline-dark "
                    onClick={() => dispatch(addToCart(product))}
                  >
                    +
                  </button>

                </div>

                  <div className="border rounded-pill shadow-sm px-3 py-2 d-inline-flex align-items-center gap-3 bg-light">

                    <span className="d-flex align-items-center gap-1">
                      <LikeIcon width={20} height={20} className="text-success" onClick={handleLikeCount}/>
                      <span className="badge bg-success-subtle text-success">{likeCount}</span>
                    </span>

                    <span className="vr"></span>

                    <span className="d-flex align-items-center gap-1">
                      <ViewIcon width={20} height={20} className="text-primary" />
                      <span className="badge bg-primary-subtle text-primary">{viewCount}</span>
                    </span>

                  </div>

                  <br />
                  <br />


                {/* BUTTONS */}          
                <div className="d-flex gap-2">
                  <NavLink
                    to="/checkout"
                    className="btn btn-success w-50"
                    onClick={() => dispatch(addToCart(product))}
                  >
                    Checkout
                  </NavLink>

                  <button className="btn btn-dark w-50" onClick={() => dispatch(addToCart(product))}>
                    Add To Cart
                  </button>
                </div>

                  <br />      
                <div className="product-info">
                    <div dangerouslySetInnerHTML={{ __html: product.product_info}}/>
                </div>

              </div>
          </div>

          {/* TABS */}
          <div className="mt-5">
            <ul className="nav nav-tabs" id="productTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="desc-tab" data-bs-toggle="tab" data-bs-target="#description" type="button" role="tab">
                  Description
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button className="nav-link" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab">
                  Review
                </button>
              </li>
           
            </ul>

            <div className="tab-content border border-top-0 p-3" id="productTabContent">

              {/* DESCRIPTION TAB */}
              <div className="tab-pane fade show active"  id="description" role="tabpanel">
                <div dangerouslySetInnerHTML={{ __html: product.product_description}}/>
              </div>

              {/* REVIEW TAB */}
              <div className="tab-pane fade" id="review" role="tabpanel">
                 <ReviewSection productId={productDetails.id} />
              </div>
            </div>
          </div>
      </div>
    </>
  );
};

export default ProductDetailsLayout;
